export default __webpack_public_path__ + "static/media/December2013.1f90480e.png";